<template>
  <div class="import">
    <div class="import-entrance">
      <h3 style="margin:20px auto;">将您的本地数据导入到系统中的{{ ext.title }}列表</h3>
      <div class="c-flex">
        <div class="entrance-card">
          <img src="@/assets/import1.svg" style="height: 120px;object-fit: contain;" />
          <h4 style="margin:8px 0;font-size: 16px;font-weight:600;">新增导入</h4>
          <p style="font-size: 12px;line-height: 18px;">
            将本地的客户、公司、产品、或其他业务单据数据导入，新增到系统中。
          </p>
          <div>
            <el-upload
              :class="file.path.length > 0 ? 'upload-disable' : ''"
              :action="upload.url"
              :data="upload.data"
              :file-list="file.list"
              :multiple="false"
              list-type="text"
              :limit="1"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file);
                }
              "
              :on-success="
                (response, file, fileList) => {
                  return uploadSuccess(response, file, fileList, 'file.path', false);
                }
              "
              :on-error="osg.uploadError"
              :on-remove="
                (file, fileList) => {
                  return beforeRemove(file, fileList, 'file.path', false);
                }
              "
              :on-preview="osg.uploadPreview"
            >
              <el-button
                type="primary"
                style="margin-top:20px;"
                :disabled="file.path.length > 0 ? true : false"
                @click="importType = ''"
              >
                选择文件
              </el-button>
            </el-upload>
          </div>
        </div>
        <div class="entrance-card">
          <img src="@/assets/import2.svg" style="height: 120px;object-fit: contain;" />
          <h4 style="margin:8px 0;font-size: 16px;font-weight:600;">修改导入</h4>
          <p style="font-size: 12px;line-height: 18px;">
            将本地的客户、公司、产品、或其他业务单据数据导入，覆盖系统中现有数据。
          </p>
          <div>
            <el-upload
              :class="file.path.length > 0 ? 'upload-disable' : ''"
              :action="upload.url"
              :data="upload.data"
              :file-list="file.list"
              :multiple="false"
              list-type="text"
              :limit="1"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file);
                }
              "
              :on-success="
                (response, file, fileList) => {
                  return uploadSuccess(response, file, fileList, 'file.path', false);
                }
              "
              :on-error="osg.uploadError"
              :on-remove="
                (file, fileList) => {
                  return beforeRemove(file, fileList, 'file.path', false);
                }
              "
              :on-preview="osg.uploadPreview"
            >
              <el-button
                type="primary"
                style="margin-top:20px;"
                :disabled="file.path.length > 0 ? true : false"
                @click="importType = 'update'"
              >
                选择文件
              </el-button>
            </el-upload>
          </div>
        </div>
      </div>
      <h4 style="margin:30px auto 10px">需要帮助入门？</h4>
      <div class="c-flex">
        <el-link type="primary" @click="displayWizard({ colName: 'import', show: true })">
          查看导入指南
          <i class="el-icon-s-promotion"></i>
        </el-link>
        <div
          style="background-image: linear-gradient(180deg,#cbd6e2,#cbd6e2);width:1px;margin:0 7px"
        ></div>
        <el-link type="primary" @click="downloadTemplate">
          下载新增导入模板
          <i class="el-icon-document"></i>
        </el-link>
        <div
          style="background-image: linear-gradient(180deg,#cbd6e2,#cbd6e2);width:1px;margin:0 7px"
        ></div>
        <el-popover
          placement="bottom"
          width="220"
          trigger="click"
          :content="
            `请在${ext.title}列表，通过搜索或过滤器筛选出需要修改的数据，然后点击【数据导出→导出全部字段】。`
          "
        >
          <el-link slot="reference" type="primary">
            导出要修改的数据
            <i class="el-icon-document"></i>
          </el-link>
        </el-popover>
      </div>
    </div>
    <div v-if="fpi.data.length > 0 && fpi.data.find(item => item.checkData != '1')">
      <h3 style="text-align:center;margin:30px 0 10px;">
        以下是检测到的问题数据，请修改后重新提交
      </h3>
      <el-table
        :data="
          fpi.data.filter((val, index) => {
            return index + 1 > (fpi.page - 1) * fpi.rows && index + 1 <= fpi.page * fpi.rows;
          })
        "
        style="width: 100%"
        ref="table"
        highlight-current-row
      >
        <el-table-column width="60" prop="lineNumber" label="第几行"></el-table-column>
        <el-table-column
          width="200"
          prop="errorMessage"
          label="错误提示"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-for="(f, i) in extFields"
          :key="i"
          :prop="f.name"
          :label="f.nameDisp"
          :width="f.width || (i == extFields.length - 1 ? '' : '150')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column fixed="right" width="80px" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.checkData == '1'">正常</el-tag>
            <el-tag type="info" v-else-if="scope.row.handleType == 'pass'">已忽略</el-tag>
            <el-tag type="primary" v-else-if="scope.row.handleType == 'modified'">已修改</el-tag>
            <el-tag type="danger" v-else>待修改</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="150px">
          <template slot-scope="scope" v-if="scope.row.checkData != '1'">
            <el-button type="text" @click="doEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              @click="
                scope.row.handleType == 'pass'
                  ? (scope.row.handleType = '')
                  : (scope.row.handleType = 'pass');
                $forceUpdate();
              "
            >
              {{ scope.row.handleType == 'pass' ? '取消忽略' : '忽略' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" style="margin:10px auto;text-align:center;">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
        <el-button type="primary" @click="saveAll">全部提交</el-button>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="editShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form class="c-form" :model="formData" ref="formData" label-width="100px">
        <p>错误行数：第{{ formData.lineNumber }}行</p>
        <p>错误提示：{{ formData.errorMessage }}</p>
        <el-form-item :label="f.nameDisp" v-for="(f, i) in extFields" :key="i">
          <el-input
            v-model="formData[f.name]"
            @change="
              formData.handleType = 'modified';
              $forceUpdate();
            "
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import areajs from '../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'Import',
  inject: ['displayWizard'],
  data() {
    window.$this = this;
    return {
      urlParams: {},
      ext: {},
      file: { path: [], list: [], filePath: '' },
      extFields: [],
      options: {},
      fpi: {
        data: [],
        page: 1,
        rows: 10,
        total: 0
      },
      editShow: false,
      formData: {},
      importType: '', //标识是新增还是修改
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.urlParams = this.osg.paramObj();
    this.getExtByColName();
    this.getFields();
  },
  methods: {
    getExtByColName(callback) {
      this.osg.ajax('biz/ext/queryByColName/' + this.urlParams.colName + '.do', {}, res => {
        this.ext = res.entity;
        if (callback) callback();
      });
    },
    // 下载导入模板
    downloadTemplate() {
      this.osg.ajax(
        '/import/getImportTemplateDocument.do',
        { extId: this.ext._id },
        res => {
          this.osg.convertToFile(res);
        },
        {
          responseType: 'blob'
        }
      );
    },
    getFields() {
      this.osg.getFields(this.urlParams.colName, () => {}, null, null, null, null, {
        'is:importFlag|integer#and': 1
      });
    },
    uploadSuccess() {
      return this.osg.uploadSuccess(...arguments, null, null, () => {
        if (this.file.path.length > 0) {
          if (this.file.path[0].response.key) {
            this.file.filePath = this.osg.downloadUrl + this.file.path[0].response.key;
          } else if (this.file.path[0].response.data && this.file.path[0].response.data.url) {
            this.file.filePath = this.file.path[0].response.data.url;
          }
        }
        this.uploadFile();
      });
    },
    beforeRemove() {
      this.osg.beforeRemove(...arguments);
      this.fpi.data = [];
      this.fpi.page = 1;
      this.fpi.rows = 10;
      this.fpi.total = 0;
      this.$forceUpdate();
    },
    uploadFile() {
      this.osg.ajax(
        '/import/handleCheckTemplateAndData.do',
        {
          extId: this.ext._id,
          path: this.file.filePath,
          importType: this.importType,
          data: this.fpi.data.length > 0 ? JSON.stringify(this.fpi.data) : null
        },
        res => {
          this.fpi.data = res.data || [];
          this.fpi.page = 1;
          this.fpi.rows = this.fpi.rows || 10;
          if (res.data) {
            this.fpi.total = this.fpi.data.length;
            if (res.data.find(item => item.checkData != '1')) {
              this.osg.toast('以下是检测到的问题数据，请修改后重新提交');
              return;
            }
          } else {
            this.fpi.total = 0;
          }
          this.osg.alert('导入成功！', () => {
            this.$router.go(0);
          });
        }
      );
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
    },
    doEdit(row) {
      this.formData = row;
      this.editShow = true;
    },
    doSave() {
      this.editShow = false;
    },
    saveAll() {
      for (let item of this.fpi.data) {
        if (!item.handleType && item.checkData != '1') {
          this.osg.alert('请修改全部待修改数据后再提交！');
          return;
        }
      }
      this.uploadFile();
    }
  }
};
</script>
<style lang="scss" scoped>
.import {
  overflow-y: auto;
  .import-entrance {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    .entrance-card {
      width: 295px;
      height: 295px;
      border-radius: 3px;
      border: 1px solid rgb(223, 227, 235);
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 0 10px;
      padding: 15px;
      box-sizing: border-box;
      ::v-deep .upload-disable {
        .el-upload {
          pointer-events: none !important;
        }
      }
    }
  }
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }
  ::v-deep .el-table th {
    background-color: #f2f2f2 !important;
  }
}
</style>
